<template>
  <div class="exportModel">
 
    <div class="model-title">
      <div><h2>仪器设备使用记录</h2></div>
    </div>
 
    <div class="model-use-his sysTable" style="margin-top: 10px;">
      <template >
        <el-table
        :data="instrumentRecord"
        height="500px"
        v-loading="tLoading"
        style="width: 100%">
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
         >
        </el-table-column>
        <el-table-column
          prop="beforeTime"
          label="使用开始时间"
          align="center"
         >
        </el-table-column>
        <el-table-column
          prop="afterTime"
          label="使用结束时间"
          align="center"
         >
        </el-table-column>
        <el-table-column
            prop="beforeUseStates"
            width="120"
            align="center"
            label="仪器状态/正常√ 异常×"
            :render-header="renderheader">
            <template slot-scope="scope">
              <span v-if="scope.row.beforeUseStates == 0">
                <i class="el-icon-check"></i>
              </span>
              <span v-else>
                <i class="el-icon-close"></i>
              </span>
            </template>
          </el-table-column>
        <el-table-column
            prop="afterUseStates"
            width="120"
            align="center"
            label="仪器状态/正常√ 异常×"
            :render-header="renderheader">
            <template slot-scope="scope">
              <span v-if="scope.row.afterUseStates == 0">
                <i class="el-icon-check"></i>
              </span>
              <span v-else>
                <i class="el-icon-close"></i>
              </span>
            </template>
          </el-table-column>
      </el-table>
    </template>
  
    </div>

  </div>
</template>

<script>
  import { getRecordByUse,getFixedUseInfoListv2 } from "@/api/depotApi";
  import { exAppList,exportFixedByApply } from "@/api/dataMana.js"
  export default {
    name: "exportModel",
    props:{
      instrumentId:Number,
      useId:Number,
    },
    
    data(){
      return{
        date:null,
        dataDetail:{},
        tLoading:true,
        instrumentRecord:[]
      }
    },
    created() {

    },
    mounted() {
      this.getFixedUseInfoList();
    },
    watch:{
      useId(){
        this.getFixedUseInfoList()
      },
    },
    methods:{
    
          //获取固定使用记录
          getFixedUseInfoList(){
            if(!this.useId||!this.instrumentId) return
        let self = this;
        self.tLoading = true;
        let data = {
          useApplicationId: this.useId,
          instrumentId: this.instrumentId,
        };
       
        getFixedUseInfoListv2(data).then((res) => {
          if (res.code == 200) {
            self.instrumentRecord = res.data;
          }
        }).finally(() => self.tLoading = false)
      },
   
      renderheader(h, { column, $index }) {
        return h('span', {}, [
          h('span', {}, column.label.split('/')[0]),
          h('br'),
          h('span', {}, column.label.split('/')[1])
        ])
      },
    }
  }
</script>

<style lang="less" scoped>
  /*@import "~@/assets/css/myTableStyle.less";*/
  .exportModel{
    /*color: #74c8fe;*/
    .model-title{
      text-align: center;
      margin-bottom: 3%;
      .tit-button{
        float: right;
        margin-right: 1%;
      }
    }
    .model-detail{
      width: 100%;
      display: grid;//网格形式
      grid-template-columns:  45% 45%;//这里表明分为3列
      grid-gap: 10px;//每列的间隔
      margin-bottom: 20px;
      .box-detail{
        height: 32px;
        line-height: 32px;
        padding: 6px 12px;
        /*box-shadow: 0 0 15px #0071f1 inset;*/
        border-radius: 6px;
        margin-right: 10px;
        .box-title{
          width: 35%;
        }
        .box-content{
          width: 65%;
        }
      }
    }
  
    .model-bottom{
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Datamanagement/Applicationmana/components/exportModelv2.vue